export default {"src":"/_next/static/media/avatar.919ffb74.svg","height":128,"width":128};